const data = [
  {
    '': '0',
    Sub_Div_Code: '133',
    Dtr_No: '18',
    DTR_Name: '018-paikan',
    Feeder_No: '5',
    Latitude: '24.9823071',
    Longitude: '92.5210001',
    Total_Capacity_kVA: '100',
    Load: '56.39',
    Value: '1',
  },
  {
    '': '1',
    Sub_Div_Code: '133',
    Dtr_No: '44',
    DTR_Name: '044-KHELMA',
    Feeder_No: '2',
    Latitude: '24.9536851',
    Longitude: '92.4990678',
    Total_Capacity_kVA: '63',
    Load: '58.06',
    Value: '1',
  },
  {
    '': '2',
    Sub_Div_Code: '133',
    Dtr_No: '46',
    DTR_Name: '046-CRAIGPARK',
    Feeder_No: '5',
    Latitude: '25.008613',
    Longitude: '92.5257821',
    Total_Capacity_kVA: '63',
    Load: '48.92',
    Value: '1',
  },
  {
    '': '3',
    Sub_Div_Code: '133',
    Dtr_No: '50',
    DTR_Name: '050-9BPL II',
    Feeder_No: '2',
    Latitude: '24.999775',
    Longitude: '92.4433517',
    Total_Capacity_kVA: '25',
    Load: '9.28',
    Value: '1',
  },
  {
    '': '4',
    Sub_Div_Code: '133',
    Dtr_No: '54',
    DTR_Name: '054-BPR 1',
    Feeder_No: '9',
    Latitude: '24.9079803',
    Longitude: '92.6735551',
    Total_Capacity_kVA: '63',
    Load: '26.6',
    Value: '1',
  },
  {
    '': '5',
    Sub_Div_Code: '133',
    Dtr_No: '55',
    DTR_Name: '055-BPR1',
    Feeder_No: '9',
    Latitude: '24.9283744',
    Longitude: '92.6523529',
    Total_Capacity_kVA: '63',
    Load: '60.66',
    Value: '1',
  },
  {
    '': '6',
    Sub_Div_Code: '133',
    Dtr_No: '57',
    DTR_Name: '057-CHANDPUR III',
    Feeder_No: '9',
    Latitude: '24.9056361',
    Longitude: '92.6751281',
    Total_Capacity_kVA: '100',
    Load: '34.8',
    Value: '1',
  },
  {
    '': '7',
    Sub_Div_Code: '133',
    Dtr_No: '102',
    DTR_Name: 'Kalain Bazar (Near FRU)',
    Feeder_No: '2',
    Latitude: '24.9678249',
    Longitude: '92.5729239',
    Total_Capacity_kVA: '250',
    Load: '401.32',
    Value: '-1',
  },
  {
    '': '8',
    Sub_Div_Code: '133',
    Dtr_No: '103',
    DTR_Name: 'Kalain Bazar (Near Gas Agency)',
    Feeder_No: '1',
    Latitude: '24.965162',
    Longitude: '92.5757561',
    Total_Capacity_kVA: '100',
    Load: '76.64',
    Value: '1',
  },
  {
    '': '9',
    Sub_Div_Code: '133',
    Dtr_No: '105',
    DTR_Name: 'Kalain (Near KESD, APDCL)',
    Feeder_No: '2',
    Latitude: '24.9686385',
    Longitude: '92.5690119',
    Total_Capacity_kVA: '250',
    Load: '446.58',
    Value: '-1',
  },
  {
    '': '10',
    Sub_Div_Code: '133',
    Dtr_No: '106',
    DTR_Name: 'Kalain (Near PHE)',
    Feeder_No: '2',
    Latitude: '24.9664166',
    Longitude: '92.5686026',
    Total_Capacity_kVA: '100',
    Load: '113.98',
    Value: '-1',
  },
  {
    '': '11',
    Sub_Div_Code: '133',
    Dtr_No: '108',
    DTR_Name: 'Kalain Brahmangram (Near Jio)',
    Feeder_No: '2',
    Latitude: '24.9691765',
    Longitude: '92.5667413',
    Total_Capacity_kVA: '250',
    Load: '436.25',
    Value: '-1',
  },
  {
    '': '12',
    Sub_Div_Code: '133',
    Dtr_No: '109',
    DTR_Name: '109- Kalain (Tarapur- College Road)',
    Feeder_No: '2',
    Latitude: '24.9703105',
    Longitude: '92.563359',
    Total_Capacity_kVA: '63',
    Load: '117.28',
    Value: '-1',
  },
  {
    '': '13',
    Sub_Div_Code: '133',
    Dtr_No: '110',
    DTR_Name: '110-KAKRAKHAL',
    Feeder_No: '2',
    Latitude: '24.976445',
    Longitude: '92.5651117',
    Total_Capacity_kVA: '63',
    Load: '44.85',
    Value: '1',
  },
  {
    '': '14',
    Sub_Div_Code: '133',
    Dtr_No: '111',
    DTR_Name: '111-BHAIRABPUR-V',
    Feeder_No: '2',
    Latitude: '24.9582566',
    Longitude: '92.5465243',
    Total_Capacity_kVA: '100',
    Load: '75.77',
    Value: '1',
  },
  {
    '': '15',
    Sub_Div_Code: '133',
    Dtr_No: '112',
    DTR_Name: '112-BHAIRABPUR MASJID',
    Feeder_No: '2',
    Latitude: '24.964695',
    Longitude: '92.5581733',
    Total_Capacity_kVA: '16',
    Load: '19.03',
    Value: '-1',
  },
  {
    '': '16',
    Sub_Div_Code: '133',
    Dtr_No: '114',
    DTR_Name: '114-NATANPUR',
    Feeder_No: '2',
    Latitude: '24.9578008',
    Longitude: '92.5632724',
    Total_Capacity_kVA: '100',
    Load: '178.13',
    Value: '-1',
  },
  {
    '': '17',
    Sub_Div_Code: '133',
    Dtr_No: '115',
    DTR_Name: 'Boroitoli (Near Masjid)',
    Feeder_No: '2',
    Latitude: '24.9470533',
    Longitude: '92.5667217',
    Total_Capacity_kVA: '250',
    Load: '163.48',
    Value: '1',
  },
  {
    '': '18',
    Sub_Div_Code: '133',
    Dtr_No: '117',
    DTR_Name: '117-NATANPUR',
    Feeder_No: '2',
    Latitude: '24.948529',
    Longitude: '92.5645731',
    Total_Capacity_kVA: '16',
    Load: '11.95',
    Value: '1',
  },
  {
    '': '19',
    Sub_Div_Code: '133',
    Dtr_No: '118',
    DTR_Name: '118-DIGABUR BASTI',
    Feeder_No: '2',
    Latitude: '24.9489022',
    Longitude: '92.5536784',
    Total_Capacity_kVA: '100',
    Load: '46.76',
    Value: '1',
  },
  {
    '': '20',
    Sub_Div_Code: '133',
    Dtr_No: '120',
    DTR_Name: '120-BHAIRABPUR-V (NEAR KAKRAKHAL)',
    Feeder_No: '2',
    Latitude: '24.9669217',
    Longitude: '92.5540773',
    Total_Capacity_kVA: '100',
    Load: '115.63',
    Value: '-1',
  },
  {
    '': '21',
    Sub_Div_Code: '133',
    Dtr_No: '121',
    DTR_Name: '121-BHAIRABPUR-III HILUATILLA',
    Feeder_No: '2',
    Latitude: '24.93532',
    Longitude: '92.539665',
    Total_Capacity_kVA: '16',
    Load: '16.37',
    Value: '-1',
  },
  {
    '': '22',
    Sub_Div_Code: '133',
    Dtr_No: '125',
    DTR_Name: '125-SALIMABAD',
    Feeder_No: '2',
    Latitude: '24.9386353',
    Longitude: '92.527886',
    Total_Capacity_kVA: '25',
    Load: '47.99',
    Value: '-1',
  },
  {
    '': '23',
    Sub_Div_Code: '133',
    Dtr_No: '126',
    DTR_Name: '126-KAKRAKHAL',
    Feeder_No: '2',
    Latitude: '24.9723066',
    Longitude: '92.5564977',
    Total_Capacity_kVA: '250',
    Load: '195.99',
    Value: '1',
  },
  {
    '': '24',
    Sub_Div_Code: '133',
    Dtr_No: '128',
    DTR_Name: '128-KHELMA-VI',
    Feeder_No: '2',
    Latitude: '24.946875',
    Longitude: '92.47223',
    Total_Capacity_kVA: '25',
    Load: '33.77',
    Value: '-1',
  },
  {
    '': '25',
    Sub_Div_Code: '133',
    Dtr_No: '130',
    DTR_Name: '130-KHELMA VIII',
    Feeder_No: '2',
    Latitude: '24.9775874',
    Longitude: '92.5293892',
    Total_Capacity_kVA: '250',
    Load: '309.85',
    Value: '-1',
  },
  {
    '': '26',
    Sub_Div_Code: '133',
    Dtr_No: '132',
    DTR_Name: '132-BHUBANESWARNAGAR',
    Feeder_No: '9',
    Latitude: '24.9292817',
    Longitude: '92.6465267',
    Total_Capacity_kVA: '250',
    Load: '157.98',
    Value: '1',
  },
  {
    '': '27',
    Sub_Div_Code: '133',
    Dtr_No: '133',
    DTR_Name: '133-PAIKAN 25 kVA',
    Feeder_No: '5',
    Latitude: '24.9788613',
    Longitude: '92.5263126',
    Total_Capacity_kVA: '25',
    Load: '22.11',
    Value: '1',
  },
  {
    '': '28',
    Sub_Div_Code: '133',
    Dtr_No: '134',
    DTR_Name: '134-TARAPUR ULLAKHAL',
    Feeder_No: '2',
    Latitude: '24.9739033',
    Longitude: '92.5473926',
    Total_Capacity_kVA: '100',
    Load: '57.34',
    Value: '1',
  },
  {
    '': '29',
    Sub_Div_Code: '133',
    Dtr_No: '135',
    DTR_Name: 'Paikan (Near Masjid)',
    Feeder_No: '2',
    Latitude: '24.9774788',
    Longitude: '92.5120053',
    Total_Capacity_kVA: '100',
    Load: '96.88',
    Value: '1',
  },
  {
    '': '30',
    Sub_Div_Code: '133',
    Dtr_No: '139',
    DTR_Name: '139-KOROCHURA 63KVA',
    Feeder_No: '2',
    Latitude: '24.9758216',
    Longitude: '92.5355262',
    Total_Capacity_kVA: '63',
    Load: '93.43',
    Value: '-1',
  },
  {
    '': '31',
    Sub_Div_Code: '133',
    Dtr_No: '140',
    DTR_Name: '140-KHELMA 16KV',
    Feeder_No: '2',
    Latitude: '24.9730496',
    Longitude: '92.5161298',
    Total_Capacity_kVA: '63',
    Load: '48.03',
    Value: '1',
  },
  {
    '': '32',
    Sub_Div_Code: '133',
    Dtr_No: '141',
    DTR_Name: '141-KHELMA-III VII',
    Feeder_No: '2',
    Latitude: '24.9605042',
    Longitude: '92.501977',
    Total_Capacity_kVA: '16',
    Load: '17.05',
    Value: '-1',
  },
  {
    '': '33',
    Sub_Div_Code: '133',
    Dtr_No: '142',
    DTR_Name: '142-KHLMA',
    Feeder_No: '2',
    Latitude: '24.9785554',
    Longitude: '92.5192671',
    Total_Capacity_kVA: '250',
    Load: '270.73',
    Value: '-1',
  },
  {
    '': '34',
    Sub_Div_Code: '133',
    Dtr_No: '144',
    DTR_Name: '144-KHELMA II',
    Feeder_No: '2',
    Latitude: '24.9573254',
    Longitude: '92.4979798',
    Total_Capacity_kVA: '16',
    Load: '59.93',
    Value: '-1',
  },
  {
    '': '35',
    Sub_Div_Code: '133',
    Dtr_No: '145',
    DTR_Name: '145-SADIRKHAL BAZAR',
    Feeder_No: '2',
    Latitude: '24.9518244',
    Longitude: '92.4867608',
    Total_Capacity_kVA: '63',
    Load: '48.45',
    Value: '1',
  },
  {
    '': '36',
    Sub_Div_Code: '133',
    Dtr_No: '146',
    DTR_Name: '146-JALALPUR KUSIERKUL',
    Feeder_No: '2',
    Latitude: '24.992735',
    Longitude: '92.457385',
    Total_Capacity_kVA: '100',
    Load: '107.67',
    Value: '-1',
  },
  {
    '': '37',
    Sub_Div_Code: '133',
    Dtr_No: '147',
    DTR_Name: '147-TARAPUR',
    Feeder_No: '2',
    Latitude: '24.9917083',
    Longitude: '92.4432209',
    Total_Capacity_kVA: '16',
    Load: '21.01',
    Value: '-1',
  },
  {
    '': '38',
    Sub_Div_Code: '133',
    Dtr_No: '148',
    DTR_Name: '148-LEVERPUTA',
    Feeder_No: '2',
    Latitude: '24.945659',
    Longitude: '92.4661563',
    Total_Capacity_kVA: '16',
    Load: '18.18',
    Value: '-1',
  },
  {
    '': '39',
    Sub_Div_Code: '133',
    Dtr_No: '150',
    DTR_Name: '150-dudpur-63-kva',
    Feeder_No: '7',
    Latitude: '24.8731221',
    Longitude: '92.6737717',
    Total_Capacity_kVA: '100',
    Load: '168.53',
    Value: '-1',
  },
  {
    '': '40',
    Sub_Div_Code: '133',
    Dtr_No: '151',
    DTR_Name: '151-SARASPUR',
    Feeder_No: '2',
    Latitude: '24.975134',
    Longitude: '92.4996664',
    Total_Capacity_kVA: '100',
    Load: '55.11',
    Value: '1',
  },
  {
    '': '41',
    Sub_Div_Code: '133',
    Dtr_No: '153',
    DTR_Name: '153-KHELMA',
    Feeder_No: '2',
    Latitude: '24.9833766',
    Longitude: '92.5292307',
    Total_Capacity_kVA: '100',
    Load: '78.34',
    Value: '1',
  },
  {
    '': '42',
    Sub_Div_Code: '133',
    Dtr_No: '155',
    DTR_Name: '155-RAJPUR 63 KVA',
    Feeder_No: '2',
    Latitude: '24.9889367',
    Longitude: '92.4918183',
    Total_Capacity_kVA: '100',
    Load: '99.46',
    Value: '1',
  },
  {
    '': '43',
    Sub_Div_Code: '133',
    Dtr_No: '156',
    DTR_Name: '156-TALKARGRANT',
    Feeder_No: '2',
    Latitude: '24.9884867',
    Longitude: '92.4744267',
    Total_Capacity_kVA: '100',
    Load: '111.89',
    Value: '-1',
  },
  {
    '': '44',
    Sub_Div_Code: '133',
    Dtr_No: '157',
    DTR_Name: '157-MAHADEVPUR RGGVY',
    Feeder_No: '2',
    Latitude: '24.9730315',
    Longitude: '92.4644123',
    Total_Capacity_kVA: '25',
    Load: '15.96',
    Value: '1',
  },
  {
    '': '45',
    Sub_Div_Code: '133',
    Dtr_No: '159',
    DTR_Name: 'Paikan',
    Feeder_No: '2',
    Latitude: '24.9794743',
    Longitude: '92.5162463',
    Total_Capacity_kVA: '100',
    Load: '62.36',
    Value: '1',
  },
  {
    '': '46',
    Sub_Div_Code: '133',
    Dtr_No: '160',
    DTR_Name: '160-PEERNAGAR',
    Feeder_No: '2',
    Latitude: '24.9745778',
    Longitude: '92.4590091',
    Total_Capacity_kVA: '100',
    Load: '134.79',
    Value: '-1',
  },
  {
    '': '47',
    Sub_Div_Code: '133',
    Dtr_No: '162',
    DTR_Name: '162-Mahadevpur',
    Feeder_No: '2',
    Latitude: '24.958411',
    Longitude: '92.4790336',
    Total_Capacity_kVA: '25',
    Load: '36.6',
    Value: '-1',
  },
  {
    '': '48',
    Sub_Div_Code: '133',
    Dtr_No: '164',
    DTR_Name: 'Bhairabpur Part-I',
    Feeder_No: '2',
    Latitude: '24.9772193',
    Longitude: '92.5286137',
    Total_Capacity_kVA: '63',
    Load: '61.73',
    Value: '1',
  },
  {
    '': '49',
    Sub_Div_Code: '133',
    Dtr_No: '165',
    DTR_Name: '165-Bhairabpur-i(25kva RGGVY)',
    Feeder_No: '2',
    Latitude: '24.9651004',
    Longitude: '92.5453318',
    Total_Capacity_kVA: '63',
    Load: '37.94',
    Value: '1',
  },
  {
    '': '50',
    Sub_Div_Code: '133',
    Dtr_No: '168',
    DTR_Name: '168-TARAPUR',
    Feeder_No: '2',
    Latitude: '24.9929052',
    Longitude: '92.4557199',
    Total_Capacity_kVA: '100',
    Load: '112.62',
    Value: '-1',
  },
  {
    '': '51',
    Sub_Div_Code: '133',
    Dtr_No: '169',
    DTR_Name: '169-SOUTH TARAPUR',
    Feeder_No: '2',
    Latitude: '24.9911767',
    Longitude: '92.4508667',
    Total_Capacity_kVA: '25',
    Load: '32.74',
    Value: '-1',
  },
  {
    '': '52',
    Sub_Div_Code: '133',
    Dtr_No: '170',
    DTR_Name: '170-BISWAMBARPUR',
    Feeder_No: '2',
    Latitude: '24.999395',
    Longitude: '92.4441',
    Total_Capacity_kVA: '63',
    Load: '40.14',
    Value: '1',
  },
  {
    '': '53',
    Sub_Div_Code: '133',
    Dtr_No: '171',
    DTR_Name: '171-16-Digabar TE',
    Feeder_No: '2',
    Latitude: '24.9491235',
    Longitude: '92.5537207',
    Total_Capacity_kVA: '16',
    Load: '22.42',
    Value: '-1',
  },
  {
    '': '54',
    Sub_Div_Code: '133',
    Dtr_No: '176',
    DTR_Name: '176-NIJ JALALPUR II',
    Feeder_No: '2',
    Latitude: '24.9690184',
    Longitude: '92.4455317',
    Total_Capacity_kVA: '100',
    Load: '69.46',
    Value: '1',
  },
  {
    '': '55',
    Sub_Div_Code: '133',
    Dtr_No: '177',
    DTR_Name: '177-NIJ JALALPUR I',
    Feeder_No: '2',
    Latitude: '24.9688283',
    Longitude: '92.4418817',
    Total_Capacity_kVA: '63',
    Load: '51.13',
    Value: '1',
  },
  {
    '': '56',
    Sub_Div_Code: '133',
    Dtr_No: '178',
    DTR_Name: '178-KHELMA JALALPUR',
    Feeder_No: '2',
    Latitude: '24.9533152',
    Longitude: '92.4891377',
    Total_Capacity_kVA: '25',
    Load: '8.59',
    Value: '1',
  },
  {
    '': '57',
    Sub_Div_Code: '133',
    Dtr_No: '180',
    DTR_Name: '180-KARABALAGRANT 16KVA',
    Feeder_No: '2',
    Latitude: '25.017396',
    Longitude: '92.4394882',
    Total_Capacity_kVA: '16',
    Load: '14.47',
    Value: '1',
  },
  {
    '': '58',
    Sub_Div_Code: '133',
    Dtr_No: '181',
    DTR_Name: '181-GUMRAHGRANT 16KVA',
    Feeder_No: '2',
    Latitude: '24.9997368',
    Longitude: '92.438912',
    Total_Capacity_kVA: '16',
    Load: '47.95',
    Value: '-1',
  },
  {
    '': '59',
    Sub_Div_Code: '133',
    Dtr_No: '187',
    DTR_Name: '187-BHAIRABPUR-V',
    Feeder_No: '2',
    Latitude: '24.9596713',
    Longitude: '92.5561959',
    Total_Capacity_kVA: '63',
    Load: '73.19',
    Value: '-1',
  },
  {
    '': '60',
    Sub_Div_Code: '133',
    Dtr_No: '190',
    DTR_Name: '190-BHAIRABPUR-I',
    Feeder_No: '2',
    Latitude: '24.96872',
    Longitude: '92.4374547',
    Total_Capacity_kVA: '16',
    Load: '25.73',
    Value: '-1',
  },
  {
    '': '61',
    Sub_Div_Code: '133',
    Dtr_No: '202',
    DTR_Name: '202-CHALIGRAM',
    Feeder_No: '5',
    Latitude: '24.9854924',
    Longitude: '92.5705834',
    Total_Capacity_kVA: '16',
    Load: '16.17',
    Value: '-1',
  },
  {
    '': '62',
    Sub_Div_Code: '133',
    Dtr_No: '203',
    DTR_Name: '203-DHUMKAR CHALIRGRAM',
    Feeder_No: '5',
    Latitude: '24.9753902',
    Longitude: '92.5707701',
    Total_Capacity_kVA: '100',
    Load: '67.11',
    Value: '1',
  },
  {
    '': '63',
    Sub_Div_Code: '133',
    Dtr_No: '204',
    DTR_Name: '204-CHOLIGRAM 63KV',
    Feeder_No: '5',
    Latitude: '24.9812422',
    Longitude: '92.5660439',
    Total_Capacity_kVA: '63',
    Load: '49.14',
    Value: '1',
  },
  {
    '': '64',
    Sub_Div_Code: '133',
    Dtr_No: '205',
    DTR_Name: '205-GOBINDOKUPA',
    Feeder_No: '5',
    Latitude: '24.9976379',
    Longitude: '92.5256959',
    Total_Capacity_kVA: '25',
    Load: '38.28',
    Value: '-1',
  },
  {
    '': '65',
    Sub_Div_Code: '133',
    Dtr_No: '206',
    DTR_Name: '206-MEZENTA A',
    Feeder_No: '5',
    Latitude: '24.9969822',
    Longitude: '92.5761275',
    Total_Capacity_kVA: '25',
    Load: '42.86',
    Value: '-1',
  },
  {
    '': '66',
    Sub_Div_Code: '133',
    Dtr_No: '208',
    DTR_Name: '208-soligram 63-kva',
    Feeder_No: '5',
    Latitude: '24.9753915',
    Longitude: '92.5700057',
    Total_Capacity_kVA: '100',
    Load: '102.18',
    Value: '-1',
  },
  {
    '': '67',
    Sub_Div_Code: '133',
    Dtr_No: '210',
    DTR_Name: '210-majanta-te-16-kva',
    Feeder_No: '5',
    Latitude: '24.9978367',
    Longitude: '92.5670533',
    Total_Capacity_kVA: '16',
    Load: '11.77',
    Value: '1',
  },
  {
    '': '68',
    Sub_Div_Code: '133',
    Dtr_No: '212',
    DTR_Name: '212-mougram 16-kva',
    Feeder_No: '5',
    Latitude: '24.98784',
    Longitude: '92.5492533',
    Total_Capacity_kVA: '16',
    Load: '24.01',
    Value: '-1',
  },
  {
    '': '69',
    Sub_Div_Code: '133',
    Dtr_No: '213',
    DTR_Name: '213-63-KVA',
    Feeder_No: '9',
    Latitude: '24.948225',
    Longitude: '92.6438217',
    Total_Capacity_kVA: '63',
    Load: '62.14',
    Value: '1',
  },
  {
    '': '70',
    Sub_Div_Code: '133',
    Dtr_No: '214',
    DTR_Name: '214-buranga-2--100 kVA',
    Feeder_No: '9',
    Latitude: '24.9509467',
    Longitude: '92.6202567',
    Total_Capacity_kVA: '100',
    Load: '154.95',
    Value: '-1',
  },
  {
    '': '71',
    Sub_Div_Code: '133',
    Dtr_No: '215',
    DTR_Name: '215-bELTILLA-16-kva',
    Feeder_No: '5',
    Latitude: '24.9953417',
    Longitude: '92.4941183',
    Total_Capacity_kVA: '16',
    Load: '16',
    Value: '1',
  },
  {
    '': '72',
    Sub_Div_Code: '133',
    Dtr_No: '220',
    DTR_Name: '220-GUMRAH BAZAR',
    Feeder_No: '2',
    Latitude: '24.9535133',
    Longitude: '92.5436405',
    Total_Capacity_kVA: '250',
    Load: '108.93',
    Value: '1',
  },
  {
    '': '73',
    Sub_Div_Code: '133',
    Dtr_No: '222',
    DTR_Name: 'Gumrah Kandigram (Near Sitaram Mandir)',
    Feeder_No: '2',
    Latitude: '24.9717386',
    Longitude: '92.5116168',
    Total_Capacity_kVA: '100',
    Load: '86.46',
    Value: '1',
  },
  {
    '': '74',
    Sub_Div_Code: '133',
    Dtr_No: '225',
    DTR_Name: '225-DIGORKHAL',
    Feeder_No: '5',
    Latitude: '24.9899721',
    Longitude: '92.517014',
    Total_Capacity_kVA: '25',
    Load: '21.19',
    Value: '1',
  },
  {
    '': '75',
    Sub_Div_Code: '133',
    Dtr_No: '229',
    DTR_Name: '229-RAJESHWARPUR II',
    Feeder_No: '5',
    Latitude: '24.9917735',
    Longitude: '92.4835377',
    Total_Capacity_kVA: '16',
    Load: '20.69',
    Value: '-1',
  },
  {
    '': '76',
    Sub_Div_Code: '133',
    Dtr_No: '230',
    DTR_Name: '230-megenta te 16-kva',
    Feeder_No: '5',
    Latitude: '24.9967802',
    Longitude: '92.5714094',
    Total_Capacity_kVA: '16',
    Load: '17.8',
    Value: '-1',
  },
  {
    '': '77',
    Sub_Div_Code: '133',
    Dtr_No: '231',
    DTR_Name: '231-kalainchora-100-kva',
    Feeder_No: '5',
    Latitude: '25.0121901',
    Longitude: '92.5048747',
    Total_Capacity_kVA: '25',
    Load: '10.33',
    Value: '1',
  },
  {
    '': '78',
    Sub_Div_Code: '133',
    Dtr_No: '233',
    DTR_Name: '233-SPPS65 LAKHICHERA',
    Feeder_No: '5',
    Latitude: '25.0232498',
    Longitude: '92.4868399',
    Total_Capacity_kVA: '16',
    Load: '29',
    Value: '-1',
  },
  {
    '': '79',
    Sub_Div_Code: '133',
    Dtr_No: '236',
    DTR_Name: '236-100 KVA KURKURI BHANGARPAR',
    Feeder_No: '1',
    Latitude: '24.9590683',
    Longitude: '92.5890967',
    Total_Capacity_kVA: '100',
    Load: '85.49',
    Value: '1',
  },
  {
    '': '80',
    Sub_Div_Code: '133',
    Dtr_No: '241',
    DTR_Name: '241-BATULMARAGRANT J.T.E',
    Feeder_No: '5',
    Latitude: '24.9997139',
    Longitude: '92.4609219',
    Total_Capacity_kVA: '25',
    Load: '32.69',
    Value: '-1',
  },
  {
    '': '81',
    Sub_Div_Code: '133',
    Dtr_No: '244',
    DTR_Name: '244-DUMKAR- SP-60 100 kVA',
    Feeder_No: '2',
    Latitude: '24.9677633',
    Longitude: '92.576205',
    Total_Capacity_kVA: '100',
    Load: '108.58',
    Value: '-1',
  },
  {
    '': '82',
    Sub_Div_Code: '133',
    Dtr_No: '245',
    DTR_Name: '245-JALALPUR BAZAR',
    Feeder_No: '5',
    Latitude: '25.0009083',
    Longitude: '92.4550533',
    Total_Capacity_kVA: '250',
    Load: '219.48',
    Value: '1',
  },
  {
    '': '83',
    Sub_Div_Code: '133',
    Dtr_No: '246',
    DTR_Name: '246-63-KVA',
    Feeder_No: '5',
    Latitude: '24.9869241',
    Longitude: '92.5360573',
    Total_Capacity_kVA: '63',
    Load: '27.34',
    Value: '1',
  },
  {
    '': '84',
    Sub_Div_Code: '133',
    Dtr_No: '247',
    DTR_Name: 'Punaparagrant mikirpunji1',
    Feeder_No: '5',
    Latitude: '24.9925378',
    Longitude: '92.5492918',
    Total_Capacity_kVA: '16',
    Load: '8.07',
    Value: '1',
  },
  {
    '': '85',
    Sub_Div_Code: '133',
    Dtr_No: '249',
    DTR_Name: 'Gonirgram-iii',
    Feeder_No: '7',
    Latitude: '24.8481474',
    Longitude: '92.6604985',
    Total_Capacity_kVA: '25',
    Load: '18.95',
    Value: '1',
  },
  {
    '': '86',
    Sub_Div_Code: '133',
    Dtr_No: '257',
    DTR_Name: 'Kalinagar-1',
    Feeder_No: '7',
    Latitude: '24.8709933',
    Longitude: '92.6136883',
    Total_Capacity_kVA: '63',
    Load: '44.61',
    Value: '1',
  },
  {
    '': '87',
    Sub_Div_Code: '133',
    Dtr_No: '258',
    DTR_Name: 'Gonigram-iii',
    Feeder_No: '7',
    Latitude: '24.8565724',
    Longitude: '92.6800705',
    Total_Capacity_kVA: '25',
    Load: '43.31',
    Value: '-1',
  },
  {
    '': '88',
    Sub_Div_Code: '133',
    Dtr_No: '260',
    DTR_Name: 'Gonigram-iv',
    Feeder_No: '7',
    Latitude: '24.8692375',
    Longitude: '92.6950907',
    Total_Capacity_kVA: '16',
    Load: '5.89',
    Value: '1',
  },
  {
    '': '89',
    Sub_Div_Code: '133',
    Dtr_No: '263',
    DTR_Name: 'Katirail T.E',
    Feeder_No: '8',
    Latitude: '24.9238133',
    Longitude: '92.5935917',
    Total_Capacity_kVA: '25',
    Load: '3',
    Value: '1',
  },
  {
    '': '90',
    Sub_Div_Code: '133',
    Dtr_No: '264',
    DTR_Name: 'Craigpark -4 NO Basti',
    Feeder_No: '5',
    Latitude: '25.013576',
    Longitude: '92.5176831',
    Total_Capacity_kVA: '25',
    Load: '7.4',
    Value: '1',
  },
  {
    '': '91',
    Sub_Div_Code: '133',
    Dtr_No: '267',
    DTR_Name: 'Tarinipur-iii',
    Feeder_No: '7',
    Latitude: '24.8717246',
    Longitude: '92.6329332',
    Total_Capacity_kVA: '25',
    Load: '10.46',
    Value: '1',
  },
  {
    '': '92',
    Sub_Div_Code: '133',
    Dtr_No: '303',
    DTR_Name: '303-Menum Mikirpunji 25 kVA',
    Feeder_No: '5',
    Latitude: '25.000872',
    Longitude: '92.5033323',
    Total_Capacity_kVA: '25',
    Load: '42.78',
    Value: '-1',
  },
  {
    '': '93',
    Sub_Div_Code: '133',
    Dtr_No: '306',
    DTR_Name: '306-KURKURI/BHANGARPAR',
    Feeder_No: '1',
    Latitude: '24.9568633',
    Longitude: '92.595415',
    Total_Capacity_kVA: '100',
    Load: '56.12',
    Value: '1',
  },
  {
    '': '94',
    Sub_Div_Code: '133',
    Dtr_No: '307',
    DTR_Name: 'Monipur-1 16 kVA',
    Feeder_No: '1',
    Latitude: '24.9542333',
    Longitude: '92.599904',
    Total_Capacity_kVA: '16',
    Load: '40.24',
    Value: '-1',
  },
  {
    '': '95',
    Sub_Div_Code: '133',
    Dtr_No: '308',
    DTR_Name: 'Sundhura near Kalain Bagan down',
    Feeder_No: '3',
    Latitude: '24.980374',
    Longitude: '92.5768837',
    Total_Capacity_kVA: '100',
    Load: '111.14',
    Value: '-1',
  },
  {
    '': '96',
    Sub_Div_Code: '133',
    Dtr_No: '311',
    DTR_Name: '311-Behara Pt V (Kalacheri) (Dindayal) DT- 1',
    Feeder_No: '6',
    Latitude: '24.9108265',
    Longitude: '92.6196087',
    Total_Capacity_kVA: '63',
    Load: '29.76',
    Value: '1',
  },
  {
    '': '97',
    Sub_Div_Code: '133',
    Dtr_No: '324',
    DTR_Name: '324-Chandinagar 25 kva(Dindayal)',
    Feeder_No: '8',
    Latitude: '24.9182855',
    Longitude: '92.4990599',
    Total_Capacity_kVA: '25',
    Load: '16.22',
    Value: '1',
  },
  {
    '': '98',
    Sub_Div_Code: '133',
    Dtr_No: '327',
    DTR_Name: '327-Rongpur 25 kva(Dindayal)',
    Feeder_No: '2',
    Latitude: '24.9793367',
    Longitude: '92.4243933',
    Total_Capacity_kVA: '25',
    Load: '10',
    Value: '1',
  },
  {
    '': '99',
    Sub_Div_Code: '133',
    Dtr_No: '328',
    DTR_Name: '328-Gobindapur-I 25 kva(Dindayal)',
    Feeder_No: '6',
    Latitude: '24.9158295',
    Longitude: '92.6124281',
    Total_Capacity_kVA: '25',
    Load: '11.52',
    Value: '1',
  },
  {
    '': '100',
    Sub_Div_Code: '133',
    Dtr_No: '331',
    DTR_Name: '331- Madar Pur (Dindayal) DT-1',
    Feeder_No: '8',
    Latitude: '24.8749171',
    Longitude: '92.5227254',
    Total_Capacity_kVA: '25',
    Load: '7.89',
    Value: '1',
  },
  {
    '': '101',
    Sub_Div_Code: '133',
    Dtr_No: '333',
    DTR_Name: '333-Kalainchera-63- KVA',
    Feeder_No: '5',
    Latitude: '25.0121931',
    Longitude: '92.5071962',
    Total_Capacity_kVA: '100',
    Load: '88.82',
    Value: '1',
  },
  {
    '': '102',
    Sub_Div_Code: '133',
    Dtr_No: '335',
    DTR_Name: '335-VITORKUL-16-KVA',
    Feeder_No: '5',
    Latitude: '24.991835',
    Longitude: '92.5424317',
    Total_Capacity_kVA: '16',
    Load: '14.16',
    Value: '1',
  },
  {
    '': '103',
    Sub_Div_Code: '133',
    Dtr_No: '341',
    DTR_Name: '341-BANGARPAR BAZAR',
    Feeder_No: '9',
    Latitude: '24.9221483',
    Longitude: '92.6591983',
    Total_Capacity_kVA: '100',
    Load: '124.02',
    Value: '-1',
  },
  {
    '': '104',
    Sub_Div_Code: '133',
    Dtr_No: '342',
    DTR_Name: '342-BHANGARPAR IV',
    Feeder_No: '9',
    Latitude: '24.9221694',
    Longitude: '92.6618018',
    Total_Capacity_kVA: '100',
    Load: '69.69',
    Value: '1',
  },
  {
    '': '105',
    Sub_Div_Code: '133',
    Dtr_No: '347',
    DTR_Name: '347-Chandpur V 25 kva(Dindayal)',
    Feeder_No: '9',
    Latitude: '24.8802459',
    Longitude: '92.6890964',
    Total_Capacity_kVA: '25',
    Load: '21.3',
    Value: '1',
  },
  {
    '': '106',
    Sub_Div_Code: '133',
    Dtr_No: '350',
    DTR_Name: '350-Sonapur',
    Feeder_No: '9',
    Latitude: '24.8843978',
    Longitude: '92.6899701',
    Total_Capacity_kVA: '63',
    Load: '63.03',
    Value: '-1',
  },
  {
    '': '107',
    Sub_Div_Code: '133',
    Dtr_No: '352',
    DTR_Name: '352-BIAKIMPUNJI-25-KVA',
    Feeder_No: '5',
    Latitude: '25.0206801',
    Longitude: '92.4596856',
    Total_Capacity_kVA: '16',
    Load: '15.02',
    Value: '1',
  },
  {
    '': '108',
    Sub_Div_Code: '133',
    Dtr_No: '353',
    DTR_Name: '353-BOLASHARGRANT-16-.KVA',
    Feeder_No: '5',
    Latitude: '25.0046169',
    Longitude: '92.4539044',
    Total_Capacity_kVA: '63',
    Load: '16.2',
    Value: '1',
  },
  {
    '': '109',
    Sub_Div_Code: '133',
    Dtr_No: '354',
    DTR_Name: '354-BISWAMBERPUR',
    Feeder_No: '5',
    Latitude: '25.0214017',
    Longitude: '92.4730373',
    Total_Capacity_kVA: '100',
    Load: '60.31',
    Value: '1',
  },
  {
    '': '110',
    Sub_Div_Code: '133',
    Dtr_No: '357',
    DTR_Name: '357-10 KVA',
    Feeder_No: '5',
    Latitude: '25.0167264',
    Longitude: '92.491598',
    Total_Capacity_kVA: '10',
    Load: '3.98',
    Value: '1',
  },
  {
    '': '111',
    Sub_Div_Code: '133',
    Dtr_No: '358',
    DTR_Name: '358-BALESWARGRANT',
    Feeder_No: '5',
    Latitude: '25.0063696',
    Longitude: '92.4527822',
    Total_Capacity_kVA: '16',
    Load: '25.92',
    Value: '-1',
  },
  {
    '': '112',
    Sub_Div_Code: '133',
    Dtr_No: '359',
    DTR_Name: '359-BALESWARGRANT',
    Feeder_No: '5',
    Latitude: '25.0232986',
    Longitude: '92.4914376',
    Total_Capacity_kVA: '16',
    Load: '10.9',
    Value: '1',
  },
  {
    '': '113',
    Sub_Div_Code: '133',
    Dtr_No: '361',
    DTR_Name: '361-CHANDPUR II',
    Feeder_No: '9',
    Latitude: '24.8894184',
    Longitude: '92.6716817',
    Total_Capacity_kVA: '16',
    Load: '53.88',
    Value: '-1',
  },
  {
    '': '114',
    Sub_Div_Code: '133',
    Dtr_No: '362',
    DTR_Name: '362- GOBINDAKUPA',
    Feeder_No: '5',
    Latitude: '24.991042',
    Longitude: '92.5210683',
    Total_Capacity_kVA: '63',
    Load: '121.06',
    Value: '-1',
  },
  {
    '': '115',
    Sub_Div_Code: '133',
    Dtr_No: '364',
    DTR_Name: '364-CHANDPUR',
    Feeder_No: '9',
    Latitude: '24.90004',
    Longitude: '92.663215',
    Total_Capacity_kVA: '16',
    Load: '15.94',
    Value: '1',
  },
  {
    '': '116',
    Sub_Div_Code: '133',
    Dtr_No: '368',
    DTR_Name: '368-CHANDPUR III (BELAKONA)',
    Feeder_No: '9',
    Latitude: '24.899173',
    Longitude: '92.6780843',
    Total_Capacity_kVA: '63',
    Load: '51.46',
    Value: '1',
  },
  {
    '': '117',
    Sub_Div_Code: '133',
    Dtr_No: '369',
    DTR_Name: '369-CHANDPUR III',
    Feeder_No: '9',
    Latitude: '24.8925486',
    Longitude: '92.6711184',
    Total_Capacity_kVA: '63',
    Load: '60.47',
    Value: '1',
  },
  {
    '': '118',
    Sub_Div_Code: '133',
    Dtr_No: '370',
    DTR_Name: '370-BHANGARPAR II',
    Feeder_No: '9',
    Latitude: '24.91913',
    Longitude: '92.6587917',
    Total_Capacity_kVA: '100',
    Load: '162',
    Value: '-1',
  },
  {
    '': '119',
    Sub_Div_Code: '133',
    Dtr_No: '374',
    DTR_Name: '374-RANGHAR III',
    Feeder_No: '9',
    Latitude: '24.9076133',
    Longitude: '92.6750183',
    Total_Capacity_kVA: '25',
    Load: '18.07',
    Value: '1',
  },
  {
    '': '120',
    Sub_Div_Code: '133',
    Dtr_No: '375',
    DTR_Name: '375-BHANGARPAR IV',
    Feeder_No: '9',
    Latitude: '24.9116679',
    Longitude: '92.6710812',
    Total_Capacity_kVA: '63',
    Load: '77.16',
    Value: '-1',
  },
  {
    '': '121',
    Sub_Div_Code: '133',
    Dtr_No: '377',
    DTR_Name: '377-BHEWARPAR',
    Feeder_No: '9',
    Latitude: '24.9114717',
    Longitude: '92.668865',
    Total_Capacity_kVA: '63',
    Load: '32.31',
    Value: '1',
  },
  {
    '': '122',
    Sub_Div_Code: '133',
    Dtr_No: '378',
    DTR_Name: 'Bhangarpar IV (Near Police Outpost)',
    Feeder_No: '9',
    Latitude: '24.9159429',
    Longitude: '92.6652852',
    Total_Capacity_kVA: '63',
    Load: '74.47',
    Value: '-1',
  },
  {
    '': '123',
    Sub_Div_Code: '133',
    Dtr_No: '379',
    DTR_Name: '379- Digorkhal Bazar',
    Feeder_No: '5',
    Latitude: '24.9975538',
    Longitude: '92.5164057',
    Total_Capacity_kVA: '250',
    Load: '167.37',
    Value: '1',
  },
  {
    '': '124',
    Sub_Div_Code: '133',
    Dtr_No: '384',
    DTR_Name: '384-CHANDPUR',
    Feeder_No: '1',
    Latitude: '24.9937032',
    Longitude: '92.5197963',
    Total_Capacity_kVA: '25',
    Load: '31.64',
    Value: '-1',
  },
  {
    '': '125',
    Sub_Div_Code: '133',
    Dtr_No: '385',
    DTR_Name: '385-SONAPUR',
    Feeder_No: '9',
    Latitude: '24.9055355',
    Longitude: '92.6677673',
    Total_Capacity_kVA: '100',
    Load: '21.06',
    Value: '1',
  },
  {
    '': '126',
    Sub_Div_Code: '133',
    Dtr_No: '386',
    DTR_Name: '386- KAYAJANI BASTI',
    Feeder_No: '5',
    Latitude: '24.9863721',
    Longitude: '92.5438292',
    Total_Capacity_kVA: '25',
    Load: '14.63',
    Value: '1',
  },
  {
    '': '127',
    Sub_Div_Code: '133',
    Dtr_No: '387',
    DTR_Name: '387-16-SEWTI',
    Feeder_No: '5',
    Latitude: '25.0135693',
    Longitude: '92.5099502',
    Total_Capacity_kVA: '16',
    Load: '22.26',
    Value: '-1',
  },
  {
    '': '128',
    Sub_Div_Code: '133',
    Dtr_No: '388',
    DTR_Name: '388-CHANDPUR II',
    Feeder_No: '9',
    Latitude: '24.891385',
    Longitude: '92.6665767',
    Total_Capacity_kVA: '63',
    Load: '43.98',
    Value: '1',
  },
  {
    '': '129',
    Sub_Div_Code: '133',
    Dtr_No: '390',
    DTR_Name: '390-BHANGARPAR II',
    Feeder_No: '9',
    Latitude: '24.9150517',
    Longitude: '92.6500117',
    Total_Capacity_kVA: '63',
    Load: '24.31',
    Value: '1',
  },
  {
    '': '130',
    Sub_Div_Code: '133',
    Dtr_No: '391',
    DTR_Name: '391-tingourI',
    Feeder_No: '9',
    Latitude: '24.939965',
    Longitude: '92.63556',
    Total_Capacity_kVA: '63',
    Load: '54.01',
    Value: '1',
  },
  {
    '': '131',
    Sub_Div_Code: '133',
    Dtr_No: '392',
    DTR_Name: '392-SEWTI IV',
    Feeder_No: '9',
    Latitude: '24.9167167',
    Longitude: '92.6487085',
    Total_Capacity_kVA: '63',
    Load: '52.37',
    Value: '1',
  },
  {
    '': '132',
    Sub_Div_Code: '133',
    Dtr_No: '394',
    DTR_Name: '394-16 KVA BARJATRAPUR',
    Feeder_No: '9',
    Latitude: '24.8945492',
    Longitude: '92.69898',
    Total_Capacity_kVA: '25',
    Load: '32.78',
    Value: '-1',
  },
  {
    '': '133',
    Sub_Div_Code: '133',
    Dtr_No: '396',
    DTR_Name: '396-HIYERBOND-II',
    Feeder_No: '9',
    Latitude: '24.9057083',
    Longitude: '92.6912517',
    Total_Capacity_kVA: '63',
    Load: '62.87',
    Value: '1',
  },
  {
    '': '134',
    Sub_Div_Code: '133',
    Dtr_No: '397',
    DTR_Name: '397-CHANDPUR III ( NEAR PETROL PUMP',
    Feeder_No: '9',
    Latitude: '24.9023721',
    Longitude: '92.6852968',
    Total_Capacity_kVA: '63',
    Load: '96.2',
    Value: '-1',
  },
  {
    '': '135',
    Sub_Div_Code: '133',
    Dtr_No: '398',
    DTR_Name: '398-CHANDPUR IV- AKILTIKRI',
    Feeder_No: '9',
    Latitude: '24.8996317',
    Longitude: '92.69115',
    Total_Capacity_kVA: '100',
    Load: '128.3',
    Value: '-1',
  },
  {
    '': '136',
    Sub_Div_Code: '133',
    Dtr_No: '406',
    DTR_Name: '406-Kalain TE.',
    Feeder_No: '3',
    Latitude: '24.87701',
    Longitude: '92.525155',
    Total_Capacity_kVA: '25',
    Load: '7.09',
    Value: '1',
  },
  {
    '': '137',
    Sub_Div_Code: '133',
    Dtr_No: '411',
    DTR_Name: '411- Tarinipur I(Dindayal) DT-2',
    Feeder_No: '7',
    Latitude: '24.8797644',
    Longitude: '92.6306206',
    Total_Capacity_kVA: '25',
    Load: '12.78',
    Value: '1',
  },
  {
    '': '138',
    Sub_Div_Code: '133',
    Dtr_No: '412',
    DTR_Name: '412- Karai Kandi I (Pahar Tilla) (Dindayal) DT- 2',
    Feeder_No: '8',
    Latitude: '24.8998967',
    Longitude: '92.5346967',
    Total_Capacity_kVA: '25',
    Load: '19.47',
    Value: '1',
  },
  {
    '': '139',
    Sub_Div_Code: '133',
    Dtr_No: '415',
    DTR_Name: '415- Behara Pt VI (Goralalpar) (Dindayal)',
    Feeder_No: '6',
    Latitude: '24.9216062',
    Longitude: '92.6127752',
    Total_Capacity_kVA: '25',
    Load: '12.66',
    Value: '1',
  },
  {
    '': '140',
    Sub_Div_Code: '133',
    Dtr_No: '416',
    DTR_Name: '416 Mahadevpur II(Dindayal 234)',
    Feeder_No: '2',
    Latitude: '24.9698104',
    Longitude: '92.4664566',
    Total_Capacity_kVA: '25',
    Load: '15.66',
    Value: '1',
  },
  {
    '': '141',
    Sub_Div_Code: '133',
    Dtr_No: '417',
    DTR_Name: 'SALIGRAM( BOLoRAM)25KVA  ',
    Feeder_No: '5',
    Latitude: '24.9868137',
    Longitude: '92.5676464',
    Total_Capacity_kVA: '25',
    Load: '6.46',
    Value: '1',
  },
  {
    '': '142',
    Sub_Div_Code: '133',
    Dtr_No: '418',
    DTR_Name: '418- Sewti Pt I (Santi Pt I) (Monkey Tillah) (Dindayal)',
    Feeder_No: '9',
    Latitude: '24.9392267',
    Longitude: '92.6616033',
    Total_Capacity_kVA: '25',
    Load: '16.65',
    Value: '1',
  },
  {
    '': '143',
    Sub_Div_Code: '133',
    Dtr_No: '420',
    DTR_Name: '420-RAJPUR-I',
    Feeder_No: '2',
    Latitude: '24.982069',
    Longitude: '92.5097038',
    Total_Capacity_kVA: '25',
    Load: '18.91',
    Value: '1',
  },
  {
    '': '144',
    Sub_Div_Code: '133',
    Dtr_No: '425',
    DTR_Name: '425-Mahadevpur',
    Feeder_No: '2',
    Latitude: '24.9597646',
    Longitude: '92.4814827',
    Total_Capacity_kVA: '25',
    Load: '27.7',
    Value: '-1',
  },
  {
    '': '145',
    Sub_Div_Code: '133',
    Dtr_No: '434',
    DTR_Name: 'SALIGRAM (SORARPAR)BOLO-NANKI',
    Feeder_No: '5',
    Latitude: '24.9882245',
    Longitude: '92.5672927',
    Total_Capacity_kVA: '25',
    Load: '15.28',
    Value: '1',
  },
  {
    '': '146',
    Sub_Div_Code: '133',
    Dtr_No: '437',
    DTR_Name: '437 Talkargrant (Dinndayal)',
    Feeder_No: '2',
    Latitude: '24.9881',
    Longitude: '92.4820433',
    Total_Capacity_kVA: '25',
    Load: '7.08',
    Value: '1',
  },
  {
    '': '147',
    Sub_Div_Code: '133',
    Dtr_No: '439',
    DTR_Name: '439 Talkargrant Mahadebpur (Dindayal)',
    Feeder_No: '2',
    Latitude: '24.9908449',
    Longitude: '92.4637696',
    Total_Capacity_kVA: '25',
    Load: '7.5',
    Value: '1',
  },
  {
    '': '148',
    Sub_Div_Code: '133',
    Dtr_No: '441',
    DTR_Name: 'CHANDPUR-III',
    Feeder_No: '9',
    Latitude: '24.8879282',
    Longitude: '92.6755052',
    Total_Capacity_kVA: '25',
    Load: '2.9',
    Value: '1',
  },
  {
    '': '149',
    Sub_Div_Code: '133',
    Dtr_No: '445',
    DTR_Name: '445- Jagadishpur III (Bargoal) (Dindayal)',
    Feeder_No: '8',
    Latitude: '24.9082989',
    Longitude: '92.5677021',
    Total_Capacity_kVA: '16',
    Load: '4.62',
    Value: '1',
  },
  {
    '': '150',
    Sub_Div_Code: '133',
    Dtr_No: '447',
    DTR_Name: '447 Niz- Jalalpur III',
    Feeder_No: '2',
    Latitude: '24.9860917',
    Longitude: '92.5263133',
    Total_Capacity_kVA: '63',
    Load: '41.24',
    Value: '1',
  },
  {
    '': '151',
    Sub_Div_Code: '133',
    Dtr_No: '448',
    DTR_Name: '448 Talkargrant (Dindayal)',
    Feeder_No: '5',
    Latitude: '24.9970708',
    Longitude: '92.4813319',
    Total_Capacity_kVA: '25',
    Load: '1.58',
    Value: '1',
  },
  {
    '': '152',
    Sub_Div_Code: '133',
    Dtr_No: '450',
    DTR_Name: '450- Karai Kandi I (Pahar Tilla) (Dindayal) DT- 1',
    Feeder_No: '8',
    Latitude: '24.894895',
    Longitude: '92.534905',
    Total_Capacity_kVA: '25',
    Load: '22.81',
    Value: '1',
  },
  {
    '': '153',
    Sub_Div_Code: '133',
    Dtr_No: '452',
    DTR_Name: 'VitorgongapurPt-i 25KVA',
    Feeder_No: '201',
    Latitude: '24.9435914',
    Longitude: '92.7130857',
    Total_Capacity_kVA: '25',
    Load: '25.27',
    Value: '-1',
  },
  {
    '': '154',
    Sub_Div_Code: '133',
    Dtr_No: '453',
    DTR_Name: 'KHELMA PT-II',
    Feeder_No: '2',
    Latitude: '25.0205482',
    Longitude: '92.4800435',
    Total_Capacity_kVA: '25',
    Load: '12.86',
    Value: '1',
  },
  {
    '': '155',
    Sub_Div_Code: '133',
    Dtr_No: '455',
    DTR_Name: 'Mahadevpur Pt-I (Sriguru Nagar)  25 KVA',
    Feeder_No: '2',
    Latitude: '24.9940235',
    Longitude: '92.4648439',
    Total_Capacity_kVA: '25',
    Load: '13.64',
    Value: '1',
  },
  {
    '': '156',
    Sub_Div_Code: '133',
    Dtr_No: '457',
    DTR_Name: '457-Gobindapur-I (Purba Gobingapur) (Dindayal)',
    Feeder_No: '6',
    Latitude: '24.9032183',
    Longitude: '92.6291663',
    Total_Capacity_kVA: '25',
    Load: '7',
    Value: '1',
  },
  {
    '': '157',
    Sub_Div_Code: '133',
    Dtr_No: '461',
    DTR_Name: '461-TALKARGRANT (DINDAYAL)',
    Feeder_No: '2',
    Latitude: '24.9882',
    Longitude: '92.4782',
    Total_Capacity_kVA: '25',
    Load: '11.14',
    Value: '1',
  },
  {
    '': '158',
    Sub_Div_Code: '133',
    Dtr_No: '462',
    DTR_Name: '462- MANIPUR-I (DINDAYAL)',
    Feeder_No: '1',
    Latitude: '24.9542733',
    Longitude: '92.5999867',
    Total_Capacity_kVA: '25',
    Load: '0.9',
    Value: '1',
  },
  {
    '': '159',
    Sub_Div_Code: '133',
    Dtr_No: '468',
    DTR_Name: '468- Gumra Grant (Gumrah Gaon) (Dindayal)',
    Feeder_No: '2',
    Latitude: '25.00333',
    Longitude: '92.4379412',
    Total_Capacity_kVA: '25',
    Load: '5.5',
    Value: '1',
  },
  {
    '': '160',
    Sub_Div_Code: '133',
    Dtr_No: '470',
    DTR_Name: 'Saidpur Pt I(nadirpar)  25KVA',
    Feeder_No: '8',
    Latitude: '24.9535454',
    Longitude: '92.4977021',
    Total_Capacity_kVA: '63',
    Load: '22.13',
    Value: '1',
  },
  {
    '': '161',
    Sub_Div_Code: '133',
    Dtr_No: '471',
    DTR_Name: 'Biswambarpur(Kushiarkul) 25KVA',
    Feeder_No: '2',
    Latitude: '24.9887397',
    Longitude: '92.4497036',
    Total_Capacity_kVA: '25',
    Load: '36.28',
    Value: '-1',
  },
  {
    '': '162',
    Sub_Div_Code: '133',
    Dtr_No: '501',
    DTR_Name: '501-KATIRAIL TE',
    Feeder_No: '6',
    Latitude: '24.8950853',
    Longitude: '92.5848685',
    Total_Capacity_kVA: '63',
    Load: '68.43',
    Value: '-1',
  },
  {
    '': '163',
    Sub_Div_Code: '133',
    Dtr_No: '503',
    DTR_Name: '503-SIDDIPUR',
    Feeder_No: '6',
    Latitude: '24.8791867',
    Longitude: '92.5889313',
    Total_Capacity_kVA: '63',
    Load: '98.43',
    Value: '-1',
  },
  {
    '': '164',
    Sub_Div_Code: '133',
    Dtr_No: '504',
    DTR_Name: '504-KATIRAIL',
    Feeder_No: '6',
    Latitude: '24.9071669',
    Longitude: '92.5906105',
    Total_Capacity_kVA: '250',
    Load: '93.34',
    Value: '1',
  },
  {
    '': '165',
    Sub_Div_Code: '133',
    Dtr_No: '505',
    DTR_Name: '505-SIDDIPUR',
    Feeder_No: '6',
    Latitude: '24.8799917',
    Longitude: '92.592355',
    Total_Capacity_kVA: '250',
    Load: '144.22',
    Value: '1',
  },
  {
    '': '166',
    Sub_Div_Code: '133',
    Dtr_No: '506',
    DTR_Name: '506-KATIRAIL',
    Feeder_No: '6',
    Latitude: '24.8813983',
    Longitude: '92.5869067',
    Total_Capacity_kVA: '250',
    Load: '232',
    Value: '1',
  },
  {
    '': '167',
    Sub_Div_Code: '133',
    Dtr_No: '507',
    DTR_Name: '507-NOON NAGAR',
    Feeder_No: '6',
    Latitude: '24.8948477',
    Longitude: '92.5933483',
    Total_Capacity_kVA: '250',
    Load: '105.55',
    Value: '1',
  },
  {
    '': '168',
    Sub_Div_Code: '133',
    Dtr_No: '508',
    DTR_Name: '508-TIKARPARA',
    Feeder_No: '6',
    Latitude: '24.895545',
    Longitude: '92.5906833',
    Total_Capacity_kVA: '250',
    Load: '298.12',
    Value: '-1',
  },
  {
    '': '169',
    Sub_Div_Code: '133',
    Dtr_No: '509',
    DTR_Name: '509-SIDDESWAR',
    Feeder_No: '6',
    Latitude: '24.9204385',
    Longitude: '92.6071119',
    Total_Capacity_kVA: '25',
    Load: '14.05',
    Value: '1',
  },
  {
    '': '170',
    Sub_Div_Code: '133',
    Dtr_No: '512',
    DTR_Name: '512-BEHARA VI (TINTIKRI)',
    Feeder_No: '6',
    Latitude: '24.9172384',
    Longitude: '92.6116583',
    Total_Capacity_kVA: '63',
    Load: '97.89',
    Value: '-1',
  },
  {
    '': '171',
    Sub_Div_Code: '133',
    Dtr_No: '513',
    DTR_Name: '513-KATIRAIL TE',
    Feeder_No: '6',
    Latitude: '24.9246221',
    Longitude: '92.5872981',
    Total_Capacity_kVA: '100',
    Load: '106.46',
    Value: '-1',
  },
  {
    '': '172',
    Sub_Div_Code: '133',
    Dtr_No: '514',
    DTR_Name: '514-NOONNAGAR',
    Feeder_No: '6',
    Latitude: '24.8898925',
    Longitude: '92.5946527',
    Total_Capacity_kVA: '25',
    Load: '44.92',
    Value: '-1',
  },
  {
    '': '173',
    Sub_Div_Code: '133',
    Dtr_No: '515',
    DTR_Name: '515-KATIRAIL',
    Feeder_No: '6',
    Latitude: '24.956905',
    Longitude: '92.5836833',
    Total_Capacity_kVA: '100',
    Load: '93.8',
    Value: '1',
  },
  {
    '': '174',
    Sub_Div_Code: '133',
    Dtr_No: '516',
    DTR_Name: '516-MODUA',
    Feeder_No: '6',
    Latitude: '24.956765',
    Longitude: '92.5836719',
    Total_Capacity_kVA: '100',
    Load: '93.28',
    Value: '1',
  },
  {
    '': '175',
    Sub_Div_Code: '133',
    Dtr_No: '517',
    DTR_Name: '517-NOONNAGAR',
    Feeder_No: '6',
    Latitude: '24.9308471',
    Longitude: '92.5967586',
    Total_Capacity_kVA: '100',
    Load: '65.42',
    Value: '1',
  },
  {
    '': '176',
    Sub_Div_Code: '133',
    Dtr_No: '519',
    DTR_Name: '519-HILARA-',
    Feeder_No: '6',
    Latitude: '24.9349393',
    Longitude: '92.595152',
    Total_Capacity_kVA: '100',
    Load: '90.31',
    Value: '1',
  },
  {
    '': '177',
    Sub_Div_Code: '133',
    Dtr_No: '520',
    DTR_Name: '520-CHOUDHURY PARA',
    Feeder_No: '6',
    Latitude: '24.922148',
    Longitude: '92.6008619',
    Total_Capacity_kVA: '25',
    Load: '31.15',
    Value: '-1',
  },
  {
    '': '178',
    Sub_Div_Code: '133',
    Dtr_No: '521',
    DTR_Name: '521-Hilara pamp',
    Feeder_No: '6',
    Latitude: '24.9252267',
    Longitude: '92.5910217',
    Total_Capacity_kVA: '63',
    Load: '17.38',
    Value: '1',
  },
  {
    '': '179',
    Sub_Div_Code: '133',
    Dtr_No: '522',
    DTR_Name: '522-Bihara-V Kolachoripar',
    Feeder_No: '6',
    Latitude: '24.9103985',
    Longitude: '92.6333258',
    Total_Capacity_kVA: '25',
    Load: '10.62',
    Value: '1',
  },
  {
    '': '180',
    Sub_Div_Code: '133',
    Dtr_No: '523',
    DTR_Name: '523-CHELLAH',
    Feeder_No: '6',
    Latitude: '24.9054262',
    Longitude: '92.6318967',
    Total_Capacity_kVA: '63',
    Load: '47.31',
    Value: '1',
  },
  {
    '': '181',
    Sub_Div_Code: '133',
    Dtr_No: '524',
    DTR_Name: '524-LAKHIPUR III',
    Feeder_No: '6',
    Latitude: '24.9470206',
    Longitude: '92.588204',
    Total_Capacity_kVA: '250',
    Load: '75.08',
    Value: '1',
  },
  {
    '': '182',
    Sub_Div_Code: '133',
    Dtr_No: '525',
    DTR_Name: '525-CHABAGAN',
    Feeder_No: '6',
    Latitude: '24.8790639',
    Longitude: '92.5832123',
    Total_Capacity_kVA: '250',
    Load: '313.79',
    Value: '-1',
  },
  {
    '': '183',
    Sub_Div_Code: '133',
    Dtr_No: '526',
    DTR_Name: '526-BOROITOLI-V SP-44',
    Feeder_No: '6',
    Latitude: '24.9285067',
    Longitude: '92.5863767',
    Total_Capacity_kVA: '25',
    Load: '54.29',
    Value: '-1',
  },
  {
    '': '184',
    Sub_Div_Code: '133',
    Dtr_No: '527',
    DTR_Name: '527-MOHANPUR-I',
    Feeder_No: '6',
    Latitude: '24.9110925',
    Longitude: '92.6023822',
    Total_Capacity_kVA: '25',
    Load: '18.39',
    Value: '1',
  },
  {
    '': '185',
    Sub_Div_Code: '133',
    Dtr_No: '529',
    DTR_Name: '529-HILARA TE',
    Feeder_No: '6',
    Latitude: '24.9351707',
    Longitude: '92.5947399',
    Total_Capacity_kVA: '16',
    Load: '24.06',
    Value: '-1',
  },
  {
    '': '186',
    Sub_Div_Code: '133',
    Dtr_No: '530',
    DTR_Name: '530-LAKHIPUR-I',
    Feeder_No: '6',
    Latitude: '24.9609735',
    Longitude: '92.5743585',
    Total_Capacity_kVA: '16',
    Load: '35.19',
    Value: '-1',
  },
  {
    '': '187',
    Sub_Div_Code: '133',
    Dtr_No: '531',
    DTR_Name: '531-HILARA PUMP',
    Feeder_No: '6',
    Latitude: '24.9403662',
    Longitude: '92.5909925',
    Total_Capacity_kVA: '100',
    Load: '44.57',
    Value: '1',
  },
  {
    '': '188',
    Sub_Div_Code: '133',
    Dtr_No: '601',
    DTR_Name: '601-siddeshwar-63-kva',
    Feeder_No: '8',
    Latitude: '24.8770333',
    Longitude: '92.5772583',
    Total_Capacity_kVA: '63',
    Load: '79.14',
    Value: '-1',
  },
  {
    '': '189',
    Sub_Div_Code: '133',
    Dtr_No: '602',
    DTR_Name: '602-kathigorha-63-kva',
    Feeder_No: '8',
    Latitude: '24.8820036',
    Longitude: '92.5660643',
    Total_Capacity_kVA: '100',
    Load: '147.55',
    Value: '-1',
  },
  {
    '': '190',
    Sub_Div_Code: '133',
    Dtr_No: '603',
    DTR_Name: '603-charagibazar-250-kva',
    Feeder_No: '8',
    Latitude: '24.8812017',
    Longitude: '92.5551839',
    Total_Capacity_kVA: '250',
    Load: '144.36',
    Value: '1',
  },
  {
    '': '191',
    Sub_Div_Code: '133',
    Dtr_No: '604',
    DTR_Name: '604-kathigorha-63-kva',
    Feeder_No: '8',
    Latitude: '24.8851333',
    Longitude: '92.5567267',
    Total_Capacity_kVA: '63',
    Load: '41.74',
    Value: '1',
  },
  {
    '': '192',
    Sub_Div_Code: '133',
    Dtr_No: '605',
    DTR_Name: '605-KATIGORAH OLD 250',
    Feeder_No: '8',
    Latitude: '24.8776867',
    Longitude: '92.5687733',
    Total_Capacity_kVA: '250',
    Load: '346.44',
    Value: '-1',
  },
  {
    '': '193',
    Sub_Div_Code: '133',
    Dtr_No: '607',
    DTR_Name: '607-JAGADISHPUR 100',
    Feeder_No: '8',
    Latitude: '24.888185',
    Longitude: '92.5567798',
    Total_Capacity_kVA: '100',
    Load: '123.35',
    Value: '-1',
  },
  {
    '': '194',
    Sub_Div_Code: '133',
    Dtr_No: '609',
    DTR_Name: '609-haritakar-16-kva',
    Feeder_No: '8',
    Latitude: '24.8880117',
    Longitude: '92.5122867',
    Total_Capacity_kVA: '16',
    Load: '22.99',
    Value: '-1',
  },
  {
    '': '195',
    Sub_Div_Code: '133',
    Dtr_No: '610',
    DTR_Name: '610-LATHIMARA-100-KVA',
    Feeder_No: '8',
    Latitude: '24.8811583',
    Longitude: '92.5552333',
    Total_Capacity_kVA: '250',
    Load: '161.709',
    Value: '1',
  },
  {
    '': '196',
    Sub_Div_Code: '133',
    Dtr_No: '611',
    DTR_Name: 'Haritakar',
    Feeder_No: '8',
    Latitude: '24.883685',
    Longitude: '92.51593',
    Total_Capacity_kVA: '25',
    Load: '14.19',
    Value: '1',
  },
  {
    '': '197',
    Sub_Div_Code: '133',
    Dtr_No: '612',
    DTR_Name: '612-LATHIMARA-16-KVA',
    Feeder_No: '8',
    Latitude: '24.8750363',
    Longitude: '92.5431181',
    Total_Capacity_kVA: '16',
    Load: '33.9',
    Value: '-1',
  },
  {
    '': '198',
    Sub_Div_Code: '133',
    Dtr_No: '614',
    DTR_Name: '614-KATIGORAH II 100',
    Feeder_No: '8',
    Latitude: '24.9087452',
    Longitude: '92.5796577',
    Total_Capacity_kVA: '100',
    Load: '58.14',
    Value: '1',
  },
  {
    '': '199',
    Sub_Div_Code: '133',
    Dtr_No: '615',
    DTR_Name: '615-KATHIGORHA-25-KVA-',
    Feeder_No: '8',
    Latitude: '24.9051417',
    Longitude: '92.577825',
    Total_Capacity_kVA: '25',
    Load: '51.08',
    Value: '-1',
  },
  {
    '': '200',
    Sub_Div_Code: '133',
    Dtr_No: '616',
    DTR_Name: '616-KATHIGORHA-16-KVA',
    Feeder_No: '8',
    Latitude: '24.9072967',
    Longitude: '92.5788033',
    Total_Capacity_kVA: '63',
    Load: '24.68',
    Value: '1',
  },
  {
    '': '201',
    Sub_Div_Code: '133',
    Dtr_No: '619',
    DTR_Name: '619-niz kathigorha-16-kva',
    Feeder_No: '8',
    Latitude: '24.90034',
    Longitude: '92.5776933',
    Total_Capacity_kVA: '16',
    Load: '37.55',
    Value: '-1',
  },
  {
    '': '202',
    Sub_Div_Code: '133',
    Dtr_No: '623',
    DTR_Name: '623-JAGADISHPUR V 100',
    Feeder_No: '8',
    Latitude: '24.8987683',
    Longitude: '92.5589963',
    Total_Capacity_kVA: '100',
    Load: '72.06',
    Value: '1',
  },
  {
    '': '203',
    Sub_Div_Code: '133',
    Dtr_No: '624',
    DTR_Name: '624-JAGADISHPUR IV 63',
    Feeder_No: '8',
    Latitude: '24.8918896',
    Longitude: '92.5681629',
    Total_Capacity_kVA: '63',
    Load: '99.92',
    Value: '-1',
  },
  {
    '': '204',
    Sub_Div_Code: '133',
    Dtr_No: '626',
    DTR_Name: '626-JAGADISHPUR IV 63',
    Feeder_No: '8',
    Latitude: '24.8974796',
    Longitude: '92.5680284',
    Total_Capacity_kVA: '63',
    Load: '68.68',
    Value: '-1',
  },
  {
    '': '205',
    Sub_Div_Code: '133',
    Dtr_No: '629',
    DTR_Name: '629-LATHIMARA-100-KVA',
    Feeder_No: '8',
    Latitude: '24.8791514',
    Longitude: '92.5452838',
    Total_Capacity_kVA: '100',
    Load: '111.31',
    Value: '-1',
  },
  {
    '': '206',
    Sub_Div_Code: '133',
    Dtr_No: '631',
    DTR_Name: '631-KATHIGORHA-16-KVA',
    Feeder_No: '8',
    Latitude: '24.9000817',
    Longitude: '92.5736367',
    Total_Capacity_kVA: '16',
    Load: '24.73',
    Value: '-1',
  },
  {
    '': '207',
    Sub_Div_Code: '133',
    Dtr_No: '632',
    DTR_Name: '632-talitakar-63-kva',
    Feeder_No: '8',
    Latitude: '24.8835946',
    Longitude: '92.5251355',
    Total_Capacity_kVA: '63',
    Load: '157.25',
    Value: '-1',
  },
  {
    '': '208',
    Sub_Div_Code: '133',
    Dtr_No: '634',
    DTR_Name: '634-CHANDINAGAR-16--KVA',
    Feeder_No: '8',
    Latitude: '24.9244727',
    Longitude: '92.4971552',
    Total_Capacity_kVA: '16',
    Load: '11.69',
    Value: '1',
  },
  {
    '': '209',
    Sub_Div_Code: '133',
    Dtr_No: '635',
    DTR_Name: '635-JOGODISHPUR-16-KVA',
    Feeder_No: '8',
    Latitude: '24.9099724',
    Longitude: '92.5599661',
    Total_Capacity_kVA: '16',
    Load: '21.22',
    Value: '-1',
  },
  {
    '': '210',
    Sub_Div_Code: '133',
    Dtr_No: '637',
    DTR_Name: '637-CHANDINAGAR-1-16-KVA',
    Feeder_No: '8',
    Latitude: '24.9284735',
    Longitude: '92.5002039',
    Total_Capacity_kVA: '16',
    Load: '7.59',
    Value: '1',
  },
  {
    '': '211',
    Sub_Div_Code: '133',
    Dtr_No: '640',
    DTR_Name: '640-HARINAGAR-63-KVA',
    Feeder_No: '8',
    Latitude: '24.8929134',
    Longitude: '92.4987646',
    Total_Capacity_kVA: '63',
    Load: '45.03',
    Value: '1',
  },
  {
    '': '212',
    Sub_Div_Code: '133',
    Dtr_No: '642',
    DTR_Name: '642-HORINAGAR II',
    Feeder_No: '8',
    Latitude: '24.8816267',
    Longitude: '92.5028967',
    Total_Capacity_kVA: '63',
    Load: '13.26',
    Value: '1',
  },
  {
    '': '213',
    Sub_Div_Code: '133',
    Dtr_No: '646',
    DTR_Name: '646-HARINAGAR II',
    Feeder_No: '8',
    Latitude: '24.88314',
    Longitude: '92.5033848',
    Total_Capacity_kVA: '100',
    Load: '35.38',
    Value: '1',
  },
  {
    '': '214',
    Sub_Div_Code: '133',
    Dtr_No: '1003',
    DTR_Name: 'Chandpur-I (Nokyary) (Near PHE)',
    Feeder_No: '7',
    Latitude: '24.8881058',
    Longitude: '92.6517365',
    Total_Capacity_kVA: '25',
    Load: '48.39',
    Value: '-1',
  },
  {
    '': '215',
    Sub_Div_Code: '133',
    Dtr_No: '1005',
    DTR_Name: 'Chandpur-I ( Near Masjid)',
    Feeder_No: '7',
    Latitude: '24.8866357',
    Longitude: '92.656414',
    Total_Capacity_kVA: '25',
    Load: '24.82',
    Value: '1',
  },
  {
    '': '216',
    Sub_Div_Code: '133',
    Dtr_No: '1009',
    DTR_Name: '1009- Dudhpur Lamargram (Dindayal)',
    Feeder_No: '7',
    Latitude: '24.8805672',
    Longitude: '92.6561599',
    Total_Capacity_kVA: '25',
    Load: '55.21',
    Value: '-1',
  },
  {
    '': '217',
    Sub_Div_Code: '133',
    Dtr_No: '1010',
    DTR_Name: '1010-Lakhipur-III (Dindayal) DT-1',
    Feeder_No: '6',
    Latitude: '24.9022079',
    Longitude: '92.6348132',
    Total_Capacity_kVA: '25',
    Load: '16.23',
    Value: '1',
  },
  {
    '': '218',
    Sub_Div_Code: '133',
    Dtr_No: '1014',
    DTR_Name: '1014-Khelma III (Dindayal)',
    Feeder_No: '2',
    Latitude: '24.9632297',
    Longitude: '92.5064162',
    Total_Capacity_kVA: '63',
    Load: '22.56',
    Value: '1',
  },
  {
    '': '219',
    Sub_Div_Code: '133',
    Dtr_No: '1015',
    DTR_Name: '1015-Sarajpur (Daspara) (Dindayal)',
    Feeder_No: '2',
    Latitude: '24.9656625',
    Longitude: '92.4871535',
    Total_Capacity_kVA: '63',
    Load: '35.87',
    Value: '1',
  },
  {
    '': '220',
    Sub_Div_Code: '133',
    Dtr_No: '1016',
    DTR_Name: '1016-Paikan (Ujangram) (Dindayal)',
    Feeder_No: '5',
    Latitude: '24.983425',
    Longitude: '92.5234193',
    Total_Capacity_kVA: '25',
    Load: '11.76',
    Value: '1',
  },
  {
    '': '221',
    Sub_Div_Code: '133',
    Dtr_No: '1017',
    DTR_Name: '1017- Craigpark Mikir Punjee (Shivtilla) (Dindayal)',
    Feeder_No: '5',
    Latitude: '25.0056752',
    Longitude: '92.5290112',
    Total_Capacity_kVA: '25',
    Load: '11.78',
    Value: '1',
  },
  {
    '': '222',
    Sub_Div_Code: '133',
    Dtr_No: '1025',
    DTR_Name: '1025-Saidpur II (Kalibari) (Dindayal)',
    Feeder_No: '8',
    Latitude: '24.9330799',
    Longitude: '92.4918628',
    Total_Capacity_kVA: '25',
    Load: '13.68',
    Value: '1',
  },
  {
    '': '223',
    Sub_Div_Code: '133',
    Dtr_No: '1028',
    DTR_Name: '1028- Baraitoli Pt IV (Dindayal) DT-1',
    Feeder_No: '2',
    Latitude: '24.92543',
    Longitude: '92.5728383',
    Total_Capacity_kVA: '100',
    Load: '2.49',
    Value: '1',
  },
  {
    '': '224',
    Sub_Div_Code: '133',
    Dtr_No: '1029',
    DTR_Name: '1029- Baraitoli Pt IV (Dindayal) DT-2',
    Feeder_No: '2',
    Latitude: '24.9230216',
    Longitude: '92.5676126',
    Total_Capacity_kVA: '25',
    Load: '12',
    Value: '1',
  },
  {
    '': '225',
    Sub_Div_Code: '133',
    Dtr_No: '1032',
    DTR_Name: '1032- Mahadevpur (Talkargrant) (Dindayal)',
    Feeder_No: '2',
    Latitude: '24.9889745',
    Longitude: '92.4697754',
    Total_Capacity_kVA: '25',
    Load: '9.82',
    Value: '1',
  },
  {
    '': '226',
    Sub_Div_Code: '133',
    Dtr_No: '1033',
    DTR_Name: '1033- Mahanpur (Near Samsul House) DT- 2',
    Feeder_No: '6',
    Latitude: '24.9120345',
    Longitude: '92.6110038',
    Total_Capacity_kVA: '25',
    Load: '33.89',
    Value: '-1',
  },
  {
    '': '227',
    Sub_Div_Code: '133',
    Dtr_No: '1034',
    DTR_Name: '1034-Bhairabpur II (16 kva)',
    Feeder_No: '2',
    Latitude: '24.9371434',
    Longitude: '92.5374317',
    Total_Capacity_kVA: '16',
    Load: '28.47',
    Value: '-1',
  },
  {
    '': '228',
    Sub_Div_Code: '133',
    Dtr_No: '1037',
    DTR_Name: '1037- Sewti Pt IV (Dindayal)',
    Feeder_No: '9',
    Latitude: '24.9076933',
    Longitude: '92.6451983',
    Total_Capacity_kVA: '63',
    Load: '23.58',
    Value: '1',
  },
  {
    '': '229',
    Sub_Div_Code: '133',
    Dtr_No: '1038',
    DTR_Name: '1038- Bhairabpr I (Near M E School) (SOUBHAGYA)',
    Feeder_No: '2',
    Latitude: '24.9555573',
    Longitude: '92.5450503',
    Total_Capacity_kVA: '100',
    Load: '14.12',
    Value: '1',
  },
  {
    '': '230',
    Sub_Div_Code: '133',
    Dtr_No: '1042',
    DTR_Name: '1042- Dudpur II (SANJOG)',
    Feeder_No: '7',
    Latitude: '24.8600232',
    Longitude: '92.6782089',
    Total_Capacity_kVA: '25',
    Load: '7.35',
    Value: '1',
  },
  {
    '': '231',
    Sub_Div_Code: '133',
    Dtr_No: '1045',
    DTR_Name: '1045- Sraspur (SANJOG)',
    Feeder_No: '2',
    Latitude: '24.9638836',
    Longitude: '92.4855904',
    Total_Capacity_kVA: '25',
    Load: '40.52',
    Value: '-1',
  },
  {
    '': '232',
    Sub_Div_Code: '133',
    Dtr_No: '1047',
    DTR_Name: '1047- Lahamali (SANJOG) 25',
    Feeder_No: '8',
    Latitude: '24.8852686',
    Longitude: '92.5550845',
    Total_Capacity_kVA: '25',
    Load: '58.42',
    Value: '-1',
  },
  {
    '': '233',
    Sub_Div_Code: '133',
    Dtr_No: '1048',
    DTR_Name: '1048- Mahadevpur III',
    Feeder_No: '2',
    Latitude: '24.9576767',
    Longitude: '92.4696317',
    Total_Capacity_kVA: '25',
    Load: '25.48',
    Value: '-1',
  },
  {
    '': '234',
    Sub_Div_Code: '133',
    Dtr_No: '1049',
    DTR_Name: '1049- Bhangarpar III & IV',
    Feeder_No: '9',
    Latitude: '24.91478',
    Longitude: '92.660075',
    Total_Capacity_kVA: '25',
    Load: '22.58',
    Value: '1',
  },
  {
    '': '235',
    Sub_Div_Code: '133',
    Dtr_No: '1057',
    DTR_Name: '1057- Buribail III',
    Feeder_No: '7',
    Latitude: '24.870244',
    Longitude: '92.723572',
    Total_Capacity_kVA: '25',
    Load: '23.86',
    Value: '1',
  },
  {
    '': '236',
    Sub_Div_Code: '133',
    Dtr_No: '1059',
    DTR_Name: '1059- Khelma II (SANJOG)',
    Feeder_No: '2',
    Latitude: '24.9638576',
    Longitude: '92.4897577',
    Total_Capacity_kVA: '25',
    Load: '12.29',
    Value: '1',
  },
  {
    '': '237',
    Sub_Div_Code: '133',
    Dtr_No: '2009',
    DTR_Name: 'Lakhipur III (Near Manipuri Mandir)',
    Feeder_No: '6',
    Latitude: '24.9432283',
    Longitude: '92.5897883',
    Total_Capacity_kVA: '25',
    Load: '25.68',
    Value: '-1',
  },
  {
    '': '238',
    Sub_Div_Code: '133',
    Dtr_No: '2010',
    DTR_Name: 'Lakhipur II (Near Gas Agency)',
    Feeder_No: '6',
    Latitude: '24.9518193',
    Longitude: '92.5868498',
    Total_Capacity_kVA: '25',
    Load: '12.6',
    Value: '1',
  },
  {
    '': '239',
    Sub_Div_Code: '133',
    Dtr_No: '2013',
    DTR_Name: 'Barailtoli (Hilarkandi) (Near Itt Bhatta)',
    Feeder_No: '6',
    Latitude: '24.9480118',
    Longitude: '92.5799013',
    Total_Capacity_kVA: '63',
    Load: '21',
    Value: '1',
  },
  {
    '': '240',
    Sub_Div_Code: '133',
    Dtr_No: '2014',
    DTR_Name: 'Mohanpur II (Near ONGC)',
    Feeder_No: '6',
    Latitude: '24.8912615',
    Longitude: '92.5928227',
    Total_Capacity_kVA: '25',
    Load: '8.33',
    Value: '1',
  },
  {
    '': '241',
    Sub_Div_Code: '133',
    Dtr_No: '2015',
    DTR_Name: 'Mohanpur II (Khanjalla)',
    Feeder_No: '6',
    Latitude: '24.8947567',
    Longitude: '92.586095',
    Total_Capacity_kVA: '25',
    Load: '55.17',
    Value: '-1',
  },
  {
    '': '242',
    Sub_Div_Code: '133',
    Dtr_No: '2016',
    DTR_Name: 'Khelma-IV(DDUGJY)',
    Feeder_No: '2',
    Latitude: '24.9217317',
    Longitude: '92.601031',
    Total_Capacity_kVA: '63',
    Load: '15.49',
    Value: '1',
  },
  {
    '': '243',
    Sub_Div_Code: '133',
    Dtr_No: '2017',
    DTR_Name: 'Chandpur II (Near Natun LP School)',
    Feeder_No: '9',
    Latitude: '24.8890067',
    Longitude: '92.6663333',
    Total_Capacity_kVA: '25',
    Load: '8.43',
    Value: '1',
  },
  {
    '': '244',
    Sub_Div_Code: '133',
    Dtr_No: '2034',
    DTR_Name: 'Tikarbosti(NearIOC)25KVA',
    Feeder_No: '201',
    Latitude: '24.9449015',
    Longitude: '92.7173748',
    Total_Capacity_kVA: '25',
    Load: '27.47',
    Value: '-1',
  },
  {
    '': '245',
    Sub_Div_Code: '133',
    Dtr_No: '2039',
    DTR_Name: 'SONAPUR III(MOROITOL)63KVA',
    Feeder_No: '201',
    Latitude: '24.9321317',
    Longitude: '92.6898139',
    Total_Capacity_kVA: '63',
    Load: '27.81',
    Value: '1',
  },
  {
    '': '246',
    Sub_Div_Code: '133',
    Dtr_No: '2041',
    DTR_Name: 'SonapurPTI(Kunagram)25KVA',
    Feeder_No: '201',
    Latitude: '24.9371133',
    Longitude: '92.6760321',
    Total_Capacity_kVA: '25',
    Load: '38.65',
    Value: '-1',
  },
  {
    '': '247',
    Sub_Div_Code: '133',
    Dtr_No: '2042',
    DTR_Name: 'SunapurPT-i(NearSchool)25KVA',
    Feeder_No: '201',
    Latitude: '24.9368481',
    Longitude: '92.6729154',
    Total_Capacity_kVA: '25',
    Load: '24.51',
    Value: '1',
  },
  {
    '': '248',
    Sub_Div_Code: '133',
    Dtr_No: '2045',
    DTR_Name: 'Sonapur PT I(Dispur) 100 kva',
    Feeder_No: '201',
    Latitude: '24.9338483',
    Longitude: '92.6674865',
    Total_Capacity_kVA: '100',
    Load: '68.78',
    Value: '1',
  },
  {
    '': '249',
    Sub_Div_Code: '133',
    Dtr_No: '2068',
    DTR_Name: 'Bhangarpar IV',
    Feeder_No: '9',
    Latitude: '24.9190483',
    Longitude: '92.66124',
    Total_Capacity_kVA: '63',
    Load: '33.74',
    Value: '1',
  },
  {
    '': '250',
    Sub_Div_Code: '133',
    Dtr_No: '2072',
    DTR_Name: 'Khelma-III(Near Kali Mandir)',
    Feeder_No: '2',
    Latitude: '24.9609532',
    Longitude: '92.5036777',
    Total_Capacity_kVA: '25',
    Load: '20.15',
    Value: '1',
  },
  {
    '': '251',
    Sub_Div_Code: '133',
    Dtr_No: '2073',
    DTR_Name: 'Rajpur Talkar grant 2',
    Feeder_No: '2',
    Latitude: '24.9887754',
    Longitude: '92.4840191',
    Total_Capacity_kVA: '25',
    Load: '19.11',
    Value: '1',
  },
  {
    '': '252',
    Sub_Div_Code: '133',
    Dtr_No: '2077',
    DTR_Name: 'HARINAGAR PT II (NEW 25KVA)',
    Feeder_No: '8',
    Latitude: '24.890085',
    Longitude: '92.497935',
    Total_Capacity_kVA: '25',
    Load: '13',
    Value: '1',
  },
  {
    '': '253',
    Sub_Div_Code: '133',
    Dtr_No: '2078',
    DTR_Name: '25KVA KATIGORAH PT II NEAR SUKRITIPUR STATION',
    Feeder_No: '8',
    Latitude: '24.8978267',
    Longitude: '92.5732533',
    Total_Capacity_kVA: '25',
    Load: '9.9',
    Value: '1',
  },
  {
    '': '254',
    Sub_Div_Code: '133',
    Dtr_No: '2079',
    DTR_Name: 'Bhairabpur Pt II New 16 kVA',
    Feeder_No: '2',
    Latitude: '24.9331093',
    Longitude: '92.5384153',
    Total_Capacity_kVA: '16',
    Load: '15',
    Value: '1',
  },
  {
    '': '255',
    Sub_Div_Code: '133',
    Dtr_No: '2081',
    DTR_Name: 'BHAIRABPUR-II(SALIMABAD)',
    Feeder_No: '2',
    Latitude: '24.9391749',
    Longitude: '92.532011',
    Total_Capacity_kVA: '16',
    Load: '25',
    Value: '-1',
  },
  {
    '': '256',
    Sub_Div_Code: '133',
    Dtr_No: '2082',
    DTR_Name: 'HARINAGAR PT II NEAR MASJID 25KVA',
    Feeder_No: '8',
    Latitude: '24.88349',
    Longitude: '92.4976567',
    Total_Capacity_kVA: '25',
    Load: '63.4',
    Value: '-1',
  },
  {
    '': '257',
    Sub_Div_Code: '133',
    Dtr_No: '2084',
    DTR_Name: 'CHANDINAGAR PT II NEAR LP SCHOOL 25',
    Feeder_No: '8',
    Latitude: '24.9218404',
    Longitude: '92.4947131',
    Total_Capacity_kVA: '25',
    Load: '31.36',
    Value: '-1',
  },
  {
    '': '258',
    Sub_Div_Code: '133',
    Dtr_No: '2087',
    DTR_Name: 'NANDIRPAR NEAR BSF CAMP',
    Feeder_No: '2',
    Latitude: '24.9540415',
    Longitude: '92.4975261',
    Total_Capacity_kVA: '63',
    Load: '9.33',
    Value: '1',
  },
  {
    '': '259',
    Sub_Div_Code: '133',
    Dtr_No: '2089',
    DTR_Name: 'KUNAPARAGRANT',
    Feeder_No: '5',
    Latitude: '24.9901817',
    Longitude: '92.54935',
    Total_Capacity_kVA: '16',
    Load: '12.26',
    Value: '1',
  },
  {
    '': '260',
    Sub_Div_Code: '133',
    Dtr_No: '2090',
    DTR_Name: 'Lakhipur PT I (Near Baliuna)',
    Feeder_No: '6',
    Latitude: '24.959521',
    Longitude: '92.5740704',
    Total_Capacity_kVA: '25',
    Load: '6.9',
    Value: '1',
  },
  {
    '': '261',
    Sub_Div_Code: '133',
    Dtr_No: '2091',
    DTR_Name: 'Lakhipur PT I (Near Forest Gate)',
    Feeder_No: '6',
    Latitude: '24.962372',
    Longitude: '92.578251',
    Total_Capacity_kVA: '100',
    Load: '41.82',
    Value: '1',
  },
  {
    '': '262',
    Sub_Div_Code: '133',
    Dtr_No: '2092',
    DTR_Name: 'LEVERPUTA II',
    Feeder_No: '2',
    Latitude: '24.9554018',
    Longitude: '92.4854721',
    Total_Capacity_kVA: '16',
    Load: '38.01',
    Value: '-1',
  },
  {
    '': '263',
    Sub_Div_Code: '133',
    Dtr_No: '2099',
    DTR_Name: 'LEVERPUTA I',
    Feeder_No: '2',
    Latitude: '24.9460569',
    Longitude: '92.4629548',
    Total_Capacity_kVA: '63',
    Load: '50.06',
    Value: '1',
  },
  {
    '': '264',
    Sub_Div_Code: '133',
    Dtr_No: '2103',
    DTR_Name: 'JAGADISHPUR V',
    Feeder_No: '8',
    Latitude: '24.9026655',
    Longitude: '92.5598498',
    Total_Capacity_kVA: '25',
    Load: '36.74',
    Value: '-1',
  },
  {
    '': '265',
    Sub_Div_Code: '133',
    Dtr_No: '2105',
    DTR_Name: 'LEVERPUTA II',
    Feeder_No: '2',
    Latitude: '24.9482087',
    Longitude: '92.476852',
    Total_Capacity_kVA: '25',
    Load: '11.15',
    Value: '1',
  },
  {
    '': '266',
    Sub_Div_Code: '133',
    Dtr_No: '2106',
    DTR_Name: 'JAGADISHPUR V',
    Feeder_No: '8',
    Latitude: '24.893199',
    Longitude: '92.5580641',
    Total_Capacity_kVA: '25',
    Load: '42.36',
    Value: '-1',
  },
  {
    '': '267',
    Sub_Div_Code: '133',
    Dtr_No: '2108',
    DTR_Name: 'RONGHAR I',
    Feeder_No: '9',
    Latitude: '24.9227016',
    Longitude: '92.6727785',
    Total_Capacity_kVA: '25',
    Load: '17.68',
    Value: '1',
  },
  {
    '': '268',
    Sub_Div_Code: '133',
    Dtr_No: '2109',
    DTR_Name: 'JALALPUR ( DONARPAR )',
    Feeder_No: '2',
    Latitude: '24.9753592',
    Longitude: '92.4544688',
    Total_Capacity_kVA: '25',
    Load: '14.27',
    Value: '1',
  },
  {
    '': '269',
    Sub_Div_Code: '133',
    Dtr_No: '2110',
    DTR_Name: 'JALALPUR ( DONARPAR )',
    Feeder_No: '2',
    Latitude: '24.9768917',
    Longitude: '92.4521483',
    Total_Capacity_kVA: '63',
    Load: '16.72',
    Value: '1',
  },
  {
    '': '270',
    Sub_Div_Code: '133',
    Dtr_No: '2111',
    DTR_Name: 'Natanpur ongc',
    Feeder_No: '2',
    Latitude: '24.9953112',
    Longitude: '92.4313496',
    Total_Capacity_kVA: '25',
    Load: '8.82',
    Value: '1',
  },
  {
    '': '271',
    Sub_Div_Code: '133',
    Dtr_No: '2113',
    DTR_Name: 'DIGABOR GRANT',
    Feeder_No: '2',
    Latitude: '24.9454595',
    Longitude: '92.5485232',
    Total_Capacity_kVA: '25',
    Load: '29.91',
    Value: '-1',
  },
  {
    '': '272',
    Sub_Div_Code: '133',
    Dtr_No: '2119',
    DTR_Name: 'khelma part ii',
    Feeder_No: '2',
    Latitude: '24.963094',
    Longitude: '92.4865513',
    Total_Capacity_kVA: '25',
    Load: '4.49',
    Value: '1',
  },
  {
    '': '273',
    Sub_Div_Code: '133',
    Dtr_No: '2120',
    DTR_Name: 'khelma part ii',
    Feeder_No: '2',
    Latitude: '24.9607826',
    Longitude: '92.4857204',
    Total_Capacity_kVA: '25',
    Load: '4.41',
    Value: '1',
  },
  {
    '': '274',
    Sub_Div_Code: '133',
    Dtr_No: '2121',
    DTR_Name: 'khrelma part ii',
    Feeder_No: '2',
    Latitude: '24.9576266',
    Longitude: '92.4866441',
    Total_Capacity_kVA: '25',
    Load: '14.25',
    Value: '1',
  },
  {
    '': '275',
    Sub_Div_Code: '133',
    Dtr_No: '2122',
    DTR_Name: 'GOALNAGAR',
    Feeder_No: '2',
    Latitude: '24.9591752',
    Longitude: '92.4823453',
    Total_Capacity_kVA: '25',
    Load: '11.78',
    Value: '1',
  },
  {
    '': '276',
    Sub_Div_Code: '133',
    Dtr_No: '2138',
    DTR_Name: 'MAHADEVPUR III',
    Feeder_No: '2',
    Latitude: '24.9622032',
    Longitude: '92.471702',
    Total_Capacity_kVA: '63',
    Load: '27.97',
    Value: '1',
  },
  {
    '': '277',
    Sub_Div_Code: '133',
    Dtr_No: '2140',
    DTR_Name: 'barjatrapur(near public school)',
    Feeder_No: '9',
    Latitude: '24.9024318',
    Longitude: '92.6922736',
    Total_Capacity_kVA: '63',
    Load: '33.7',
    Value: '1',
  },
  {
    '': '278',
    Sub_Div_Code: '133',
    Dtr_No: '2141',
    DTR_Name: 'barjatrapur bus stand',
    Feeder_No: '9',
    Latitude: '24.9030752',
    Longitude: '92.7054417',
    Total_Capacity_kVA: '250',
    Load: '79.56',
    Value: '1',
  },
  {
    '': '279',
    Sub_Div_Code: '133',
    Dtr_No: '2142',
    DTR_Name: 'NATANPUR  CHOUMATHA',
    Feeder_No: '2',
    Latitude: '24.9994617',
    Longitude: '92.4271217',
    Total_Capacity_kVA: '25',
    Load: '7.43',
    Value: '1',
  },
  {
    '': '280',
    Sub_Div_Code: '133',
    Dtr_No: '2144',
    DTR_Name: 'GOKULNAGAR',
    Feeder_No: '5',
    Latitude: '25.0098',
    Longitude: '92.5022417',
    Total_Capacity_kVA: '25',
    Load: '13.72',
    Value: '1',
  },
  {
    '': '281',
    Sub_Div_Code: '133',
    Dtr_No: '2185',
    DTR_Name: 'MOHANPUR-I DDUGJY21',
    Feeder_No: '6',
    Latitude: '24.9100576',
    Longitude: '92.6016071',
    Total_Capacity_kVA: '25',
    Load: '0.99',
    Value: '1',
  },
  {
    '': '282',
    Sub_Div_Code: '133',
    Dtr_No: '2210',
    DTR_Name: 'BIHARA PT V DDUGJY21',
    Feeder_No: '9',
    Latitude: '24.9272683',
    Longitude: '92.6314067',
    Total_Capacity_kVA: '63',
    Load: '2',
    Value: '1',
  },
  {
    '': '283',
    Sub_Div_Code: '133',
    Dtr_No: '2214',
    DTR_Name: 'NIZ FULBARI PT I DDUGJY21',
    Feeder_No: '7',
    Latitude: '24.86611',
    Longitude: '92.618435',
    Total_Capacity_kVA: '25',
    Load: '4.14',
    Value: '1',
  },
  {
    '': '284',
    Sub_Div_Code: '133',
    Dtr_No: '2223',
    DTR_Name: 'SARASAPUR 1 DDUGJY21',
    Feeder_No: '2',
    Latitude: '24.9809245',
    Longitude: '92.5015992',
    Total_Capacity_kVA: '25',
    Load: '0.49',
    Value: '1',
  },
  {
    '': '285',
    Sub_Div_Code: '133',
    Dtr_No: '2246',
    DTR_Name: 'DUDPUR LAMARGAM',
    Feeder_No: '7',
    Latitude: '24.8758644',
    Longitude: '92.6528798',
    Total_Capacity_kVA: '25',
    Load: '16.96',
    Value: '1',
  },
  {
    '': '286',
    Sub_Div_Code: '133',
    Dtr_No: '2255',
    DTR_Name: 'BOROITOLI NEAR DIGABOR TE',
    Feeder_No: '2',
    Latitude: '24.9444695',
    Longitude: '92.5571892',
    Total_Capacity_kVA: '16',
    Load: '1',
    Value: '1',
  },
  {
    '': '',
    Sub_Div_Code: null,
    Dtr_No: null,
    DTR_Name: null,
    Feeder_No: null,
    Latitude: null,
    Longitude: null,
    Total_Capacity_kVA: null,
    Load: null,
    Value: null,
  },
];

export default data;
